//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref, onBeforeMount } from '@vue/composition-api'
import { getMatchGameOpenCode } from '@api'
import {
  isAndroid, isIOS, openTab, isDev, useRouter,
} from '@core/utils'
import themeConfig from '@themeConfig'
import { loadLanguageAsync } from '@/plugins/i18n'
import Game from '@/views/game/Game.vue'

export default {
  name: 'MatchesDownload',
  components: {
    Game,
  },
  setup() {
    const { route } = useRouter()

    const lang = ref('es')
    const matchCode = ref(null)
    const matchId = ref(null)
    const isChallenge = ref(false)

    const appStoreLink = ref('https://apps.apple.com/us/app/fanaty/id1461051554')
    const playStoreLink = ref('https://play.google.com/store/apps/details?id=com.fanaty')

    const updateActiveLocale = locale => {
      lang.value = locale
      loadLanguageAsync(locale)
    }

    const onPrimaryClick = () => {
      window.open(playStoreLink.value, '_blank')
    }

    onBeforeMount(async () => {
      const deepLinkMatch = 'fanaty://match_detail/'
      const deepLinkMatchIOS = `${isDev.value ? 'https://dev-console.fanaty.com' : 'https://console.fanaty.com'}/match_detail/`
      const { code } = route.value.params
      matchCode.value = code
      const response = await getMatchGameOpenCode(code)
      if (response && response.ok) {
        isChallenge.value = response.data.is_challenge === 'Y'
        matchId.value = response.data.match_id
        if (isAndroid() || isIOS()) {
          const storeDelay = 2000 // 2 segundos

          if (isIOS()) {
            // Intentar abrir el universal link con timestamp para evitar caché
            const timestamp = Date.now()
            openTab(`${deepLinkMatchIOS}${matchId.value}?t=${timestamp}`)

            // Después de 2 segundos, redirigir a App Store
            // Si la app abrió, el usuario ya no está aquí
            // Si la app no abrió, el usuario va a descargarla
            setTimeout(() => {
              window.location = appStoreLink.value
            }, storeDelay)
          } else {
            // Android: intentar abrir deep link
            window.location = `${deepLinkMatch}${matchId.value}`

            // Después de 2 segundos, redirigir a Play Store
            setTimeout(() => {
              window.location = playStoreLink.value
            }, storeDelay)
          }
        }
      }
    })

    return {
      lang,
      appStoreLink,
      playStoreLink,
      appLogoTitle: themeConfig.app.logoTitle,
      onPrimaryClick,
      updateActiveLocale,
      year: new Date().getFullYear(),
      isChallenge,
    }
  },
}
